// extracted by mini-css-extract-plugin
export default {"table_container":"TableMainResults_table_container__MFzkj","main_table":"TableMainResults_main_table__-YPd-","tabmain_tablele":"TableMainResults_tabmain_tablele__doP8p"};